import { defineMessages } from '@cookbook/solid-intl'

// Split out of `privacy-page.messages.en.js` (which also holds the full
// ~48KB of Privacy Policy body copy) so the router's document-title/meta-
// description wiring in `privacy-page-routing.js` doesn't have to eagerly
// pull that entire legal text into the boot-critical chunk just for these
// two small strings. See `tos-page-routing.messages.en.js` for the same
// pattern and rationale.
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Learn about Lodgr\u2019s privacy policy. Understand how we collect, use, and protect your personal information.',
        id: 'PrivacyPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Privacy Policy | Lodgr',
        id: 'PrivacyPage.titleMessage',
    }),
}
